<template>
  <v-dialog
    v-model="parentPortalPresentationOtherDialog"
    persistent
    max-width="300"
  >
    <v-card>
      <v-form ref="portalConfigurationFormRef">
        <v-card-title class="primary-background">
          <span>Modèle du portail</span>
          <v-spacer></v-spacer>
          <v-btn icon @click="parentPortalPresentationOtherDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row v-if="parentPortalConfiguration != null">
              <v-col cols="12">
                <v-switch
                  v-model="enableWeatherCity"
                  dense
                  label="Activer la météo"
                ></v-switch>
                <v-text-field
                  label="Ville de la météo"
                  v-if="portalConfigurationModel.has_weather != null"
                  v-model="weatherCity"
                  :disabled="!enableWeatherCity"
                ></v-text-field>
                <v-text-field
                  v-if="portalConfigurationModel.has_welcome_url != null"
                  label="Welcome URL"
                  v-model="parentPortalConfiguration.welcome_url"
                ></v-text-field>
                <v-checkbox
                  v-if="portalConfigurationModel.has_news"
                  v-model="parentPortalConfiguration.has_news"
                  label="Afficher les NEWS"
                ></v-checkbox>
              </v-col>
              <v-divider></v-divider>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="parentPortalPresentationOtherDialog = false"
          >
            Fermer
          </v-btn>
          <v-btn
            color="primary"
            :disabled="enableWeatherCity && weatherCity == ''"
            @click="updatePortal"
            :loading="loadingSave"
          >
            Enregistrer
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import { computed, ref, watch, onBeforeMount } from "@vue/composition-api";
import { usePortalConfiguration } from "@/composables/portal-configuration";

export default {
  props: {
    isInherit: Boolean,
    isBuiltIn: Boolean,
    portalOptionsId: Number,
    isGroup: Boolean,
    updatePortalConfiguration: Function,
    id: String,
    portalConfigurationModel: Object,
    group: Object,
    partner: Object,
    portalConfiguration: {
      type: Object,
      required: true,
    },
    portalPresentationOtherDialog: Boolean,
    rules: Object,
    isPortalProfile: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    /* Import des API */
    const {
      initConfigurationForm,
      portalModels,
      portalConfigurationFormRef,
      portalProfile,
    } = usePortalConfiguration();

    /* Variables */
    const enableWeatherCity = ref(false);
    const weatherCity = ref("");
    let parentPortalConfiguration = ref({});
    const loadingSave = ref(false);

    /* Computed */
    const parentPortalPresentationOtherDialog = computed({
      get: () => props.portalPresentationOtherDialog,
      set: (value) => {
        emit("update:portalPresentationOtherDialog", value);
      },
    });

    /* Méthodes */
    const updatePortal = async function () {
      loadingSave.value = true;
      const formData = {
        weather_city: parentPortalConfiguration.value.weather_city,
        welcome_url: parentPortalConfiguration.value.welcome_url,
      };
      await props.updatePortalConfiguration(props.id, formData);
      loadingSave.value = false;
    };

    /* Cycle de vie */
    onBeforeMount(() => {
      parentPortalConfiguration.value = initConfigurationForm(props);
      weatherCity.value = parentPortalConfiguration.value.weather_city;
      if (weatherCity.value != "") {
        enableWeatherCity.value = true;
      }
    });

    /* Watchers */
    watch(
      () => enableWeatherCity.value,
      (newValue) => {
        if (!newValue) {
          weatherCity.value = "";
        } else {
          weatherCity.value = parentPortalConfiguration.value.weather_city;
        }
      },
      { deep: true }
    );
    watch(
      () => weatherCity.value,
      (newValue) => {
        if (
          newValue != undefined &&
          newValue != parentPortalConfiguration.value.weather_city
        ) {
          parentPortalConfiguration.value.weather_city = newValue;
        }
      },
      { deep: true }
    );

    return {
      parentPortalConfiguration,
      portalProfile,
      portalConfigurationFormRef,
      parentPortalPresentationOtherDialog,
      portalModels,
      enableWeatherCity,
      weatherCity,
      updatePortal,
      loadingSave,
    };
  },
  methods: {},
};
</script>
